import { createReducer } from '@reduxjs/toolkit';
import { assetRef, MagicStudioShape, MAX_REFS } from './model';
import * as magicStudioActions from './actions';

const initial: MagicStudioShape = {
  visible: false,
  basket: [],
  sessionRefs: [],
  session: null,
};

export const magicStudioReducer = createReducer<MagicStudioShape>(initial, (builder) =>
  builder
    .addCase(magicStudioActions.opened, (s, a) => {
      s.visible = true;
      s.sessionRefs = a.payload.refs;
    })
    // Keep sessionRefs on close so the modal content does not flash empty while
    // the close transition plays out.
    .addCase(magicStudioActions.closed, (s) => {
      s.visible = false;
    })
    // The closing modal handing back its work. The live references become the
    // basket again — one list, so the tray shows exactly what the studio had and
    // the next open preloads exactly that.
    .addCase(magicStudioActions.sessionStashed, (s, a) => {
      s.basket = a.payload.refs;
      s.session = a.payload.session;
    })
    .addCase(magicStudioActions.sessionCleared, (s) => {
      s.basket = [];
      // Emptying sessionRefs is what tells an open studio to reset itself (see
      // the restore effect in MagicStudioModal) — the same path a fresh open
      // takes, rather than a second copy of the reset logic.
      s.sessionRefs = [];
      s.session = null;
    })
    .addCase(magicStudioActions.basketToggled, (s, a) => {
      const ref = assetRef(a.payload.asset);
      const idx = s.basket.findIndex((r) => r.key === ref.key);
      if (idx >= 0) {
        s.basket.splice(idx, 1);
      } else if (s.basket.length < MAX_REFS) {
        // Silently capped at MAX_REFS; the toggle button warns before dispatch.
        s.basket.push(ref);
      }
    })
    .addCase(magicStudioActions.basketCaptureAdded, (s, a) => {
      if (s.basket.length < MAX_REFS) s.basket.push(a.payload.ref);
    })
    .addCase(magicStudioActions.basketRemoved, (s, a) => {
      s.basket = s.basket.filter((r) => r.key !== a.payload.key);
    }),
);
